export { default } from './VerticalTabs';
export * from './VerticalTabs.types';
